exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/app/survey-container/survey-container.component.less
// module id = ../../../../../src/app/survey-container/survey-container.component.less
// module chunks = main